import type { SenderAttachment } from "./type";

export function hasTransferFiles(dataTransfer: DataTransfer | null): boolean {
  if (!dataTransfer) {
    return false;
  }
  if (dataTransfer.files && dataTransfer.files.length > 0) {
    return true;
  }
  if (Array.from(dataTransfer.types || []).includes("Files")) {
    return true;
  }
  return Array.from(dataTransfer.items || []).some(
    (item) => item.kind === "file",
  );
}

export function isImageAttachment(attachment: SenderAttachment): boolean {
  return (
    /^image\//i.test(attachment.mediaType || "") ||
    /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(attachment.filename || "")
  );
}
